module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external "textik_vendor"
// module id = 10
// module chunks = 1


//////////////////
// WEBPACK FOOTER
// external "textik_vendor"
// module id = 10
// module chunks = 1